import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=1a8e46b5"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports